import { useTheme } from "@baton/ui";
import { useEffect } from "react";
import type { TeamsTheme } from "./host.ts";

/**
 * Inside the Teams tab the application's theme is the host's (`host.ts`): mounted under the
 * application's `ThemeProvider`, this moves the theme whenever Teams reports a change, which the
 * provider cannot hear by itself. It draws nothing.
 */
export function TeamsThemeFollower({ theme }: { readonly theme: TeamsTheme }) {
  const { setTheme } = useTheme();
  useEffect(() => theme.subscribe(setTheme), [theme, setTheme]);
  return null;
}
